export const GET_RECENT_EVENTS_SUCCESS = 'GET_RECENT_EVENTS_SUCCESS';
export const SET_RECENT_EVENTS_LOADING = 'SET_RECENT_EVENTS_LOADING';
